module.exports = __webpack_public_path__ + "img/标题@2x(1).4e880625.png";